module.exports = __webpack_public_path__ + "assets/img/05.ec632e4f.png";